import { textStyles as i } from "../../textStyles.es.js";
import { transformPxToRem as o } from "../../../utils/units.es.js";
import { c as a } from "../../../index-34b1f277.js";
import { FooterAnatomy as t } from "./Footer.anatomy.es.js";
const { defineMultiStyleConfig: e } = a(t.keys), c = e({
  baseStyle: {
    root: {
      display: "flex",
      alignItems: "center",
      justifyContent: "flex-start",
      flexWrap: "wrap",
      backgroundColor: "white"
    },
    logo: {
      display: "flex",
      flexWrap: "wrap",
      alignItems: "center",
      minWidth: "min-content",
      transition: "opacity 0.2s",
      _hover: {
        opacity: 0.5
      }
    },
    social: {
      display: "flex",
      alignItems: "center"
    },
    socialItem: {
      display: "block"
    },
    socialDescription: {}
  },
  variants: {
    default: {}
  },
  sizes: {
    sm: {
      root: {
        paddingY: "spacing-200",
        paddingX: "spacing-300",
        columnGap: "spacing-200",
        rowGap: "spacing-100"
      },
      logo: {
        gap: "spacing-50",
        svg: {
          width: o(61)
        }
      },
      social: { gap: "spacing-50" },
      socialItem: { boxSize: 4 },
      socialItemYoutube: { boxSize: "22px" },
      socialDescription: i.xs
    },
    lg: {
      root: {
        paddingY: "spacing-400",
        paddingX: "spacing-300",
        columnGap: "spacing-400",
        rowGap: "spacing-100"
      },
      logo: {
        gap: "spacing-100",
        svg: {
          width: o(82)
        }
      },
      social: { gap: "spacing-100" },
      socialItem: { boxSize: 6 },
      socialItemYoutube: { boxSize: "32px" },
      socialDescription: i.xs
    }
  },
  defaultProps: {
    variant: "default",
    size: "lg"
  }
});
export {
  c as SharedFooter
};
//# sourceMappingURL=SharedFooter.es.js.map
